import {Box} from '@chakra-ui/react'
import Home from './Component/Home';
import { Loader } from '@react-three/drei';




function App() {
  return (<Box>
    <Home/>
  </Box>)
}

export default App;
